"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNotificationPath = void 0;
function getNotificationPath(service) {
    return `events/notifications/${service}`;
}
exports.getNotificationPath = getNotificationPath;
